import React from 'react';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { ReactSVG } from "react-svg";
import { Utils } from '../../Utils';

import './MyMessages.css';

class MyMessages extends React.Component {

  animationObjectRef = new React.createRef();
  
  constructor(props) {
      super(props);

      this.state = {
        message_id: 0,
        messages: [],
        hiding: false,
        show: 0,
      }
  }

  show() {
    const { message_id } = this.state;

    if (message_id === 0)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'messages',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'messages',
          formData: JSON.stringify({}),
        }
      )
      .then((res)=>{
        this.setState({messages: [...res.messages], show: true});
      });
    }
    else {
      this.setState({show: true});
    }
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  updateMessages(message_id) {
    const { messages } = this.state;
    var send_request = false;

    messages.forEach((v, i) => { 
      if (parseInt(v.id) == message_id && parseInt(v.new) === 1)
      {
        v.new = 0;
        send_request = true;
      }
    });

    const unread_messages = window.AppRef.current.state.unread_messages;
    window.AppRef.current.setState({unread_messages: unread_messages - 1});

    if (send_request)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'set_message_read_to_customer',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'set_message_read_to_customer',
          formData: JSON.stringify({message_id}),
        }
      )
      .then((res)=>{
        this.setState({messages},()=>{this.show()});
      });
    }

    window.modals.MyMessagesRef_2.current.setMessageId(message_id)
  }

  setMessageId(message_id) {
    this.setState({message_id},()=>{this.show()});
  }

  render() {
    const { message_id, messages, show, hiding } = this.state;

      let selected_message = {};
      let class_name = 'msg1'; 
      
      if (message_id)
      {
        const parentMessages = window.modals.MyMessagesRef.current.state.messages;
        selected_message = parentMessages.filter((message) => parseInt(message.id) === message_id)[0];
        class_name = 'msg2';
      }

      if (!show) return '';
      
      return <div
        className={`container floating_container page_my_messages ${hiding ? 'out' : ''} ${class_name}`}>
        <div className="content">
        
          <PageHeader parent_ref={this} no_close title={i18n.t('myMessagesTitle')} />
          
          <div className='container_inner'>
            {parseInt(message_id) === 0 ? <>
              {messages.length ? messages.map((message) => 
                <div key={message.id} className={`list_item_badge ${!message.new ? 'opened' : ''}`} onClick={() => {this.updateMessages(parseInt(message.id))}}>
                  <div className="left">
                    <label>{message.title}</label>
                    <div className="date">{message.date}</div>
                  </div>
                  <ReactSVG className="right" src="assets/images/arrow_down.svg" />
                </div>
              ) : <div className='emplty_list_message'>{i18n.t('myMessagesEmpty')}</div>}
            </>
            : <>
                {<div key={"d_"+message_id} className="selected_message">
                  <h3>{selected_message?.title}</h3>
                  <div className="date">{selected_message?.date}</div>
                  {/*<img src={selected_message.image} />*/}
                  <div className="content" dangerouslySetInnerHTML={{__html: selected_message?.content}}></div>
                </div>}
              </>
            }
          </div>
        </div>
      </div>;

  }
}

export default MyMessages;

